import { logOutAndRedirect } from 'utils/auth'

const LoopedLogin = () => {
  return (
    <section className="looped-screen">
      <p>Something went wrong, log out and sign in again</p>
      <div>
        <button className="btn -primary" onClick={logOutAndRedirect}>
          Log Out
        </button>
      </div>
    </section>
  )
}

export default LoopedLogin
